import React from 'react'
import Page from '../../pages/components/Page'
import { useParams } from 'react-router-dom'
import SingleRequest from './SingleRequest'

export default function ViewRequestPage() {

    const params = useParams()

    const requestNumber = params.request_number ? params.request_number : ""

    return(
        <Page>
            <div className="view-single-request-page-container content-section-wrapper page-container-wrapper">

                <SingleRequest requestNumber={requestNumber} showHeadSection />

            </div>
        </Page>
    )
}